module.exports = __webpack_public_path__ + "static/media/ticket.e259ef02.svg";